import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { lionSelectors } from '@rosetta/react-lion/dist/index';
import { appMainBackground, mediumGrey } from '../../../styles/colors';

import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isMobile as isMobileDetected } from 'react-device-detect';

const ErrorDiv = styled.div((props) => {
  let style = {
    position: !props.isMobile ? 'absolute' : 'relative',
    top: '0px',
    bottom: '0px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: appMainBackground,
    minHeight: props.windowHeight - 218 + 'px'
  };
  return style;
});

const ErrorBox = styled.div(() => {
  let style = {
    color: mediumGrey,
    textAlign: 'center',
    width: '480px'
  };
  return style;
});
const ErrorHeader = styled.div(() => {
  let style = {
    fontSize: '48px',
    fontWeight: '200',
    lineHeight: '50px',
    marginBottom: '30px'
  };
  return style;
});

const ErrorText = styled.div(() => {
  let style = {
    marginRight: '20px',
    marginLeft: '20px',
    fontSize: '22px',
    lineHeight: '35px'
  };
  return style;
});

//*********************************************
export class LaunchpadError extends PureComponent {
  componentWillMount = () => {};

  render = () => {
    if (!this.props.lionLoaded) {
      return null;
    }

    const isMobile = isMobileDetected;

    let errorText = this.props.lionTranslateString('system_error_internal_service_error_(500)');
    if (isMobile && this.props.location.state && this.props.location.state !== 'undefined') {
      if (this.props.location.state.msg === 'unsupportedAdmin') {
        errorText = this.props.lionTranslateString('_mobile_not_avail_admin_tools');
      } else if (this.props.location.state.msg === 'unsupportedAssessments') {
        errorText = this.props.lionTranslateString('_mobile_not_yet_avail_placemt_test');
      }
    }

    // some service call failed, show a generic error message
    return (
      <ErrorDiv isMobile={isMobile} data-qa="LaunchpadError" windowHeight={this.props.clientHeight}>
        <ErrorBox>
          <ErrorHeader>{this.props.lionTranslateString('post_assessment_error_heading')}</ErrorHeader>
          <ErrorText>{errorText}</ErrorText>
        </ErrorBox>
      </ErrorDiv>
    );
  };
}

LaunchpadError.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  }
});

const wrapActions = {};
export const LaunchpadErrorContainer = connect(
  mapStateToProps,
  wrapActions
)(withWindowDimensions(LaunchpadError));



// WEBPACK FOOTER //
// ./src/modules/launchpad/components/LaunchpadError.jsx